export default {
  BASE_URL: "psm/sp/admin",
  api: [
    {
      name: "listForAll",
      desc: "获取全部列表",
      method: "GET",
      path: "/listForAll"
    },
    {
      name: "listForSubmitted",
      desc: "获取列表",
      method: "GET",
      path: "/listForSubmitted"
    },

    {
      name: "listForAudited",
      desc: "获取已审核列表",
      method: "GET",
      path: "/listForAudited"
    },
    {
      name: "listForApproved",
      desc: "获取已评审列表",
      method: "GET",
      path: "/listForApproved"
    },
    {
      name: "listFormDataSummary",
      desc: "获取已上传资料列表",
      method: "GET",
      path: "/listFormDataSummary"
    },
    {
      name: "listForReject",
      desc: "获取驳回列表",
      method: "GET",
      path: "/listForReject"
    },
    {
      name: "listForCheck",
      desc: "获取待检查列表",
      method: "GET",
      path: "/listForCheck"
    },
    {
      name: "listForModified",
      desc: "资料修改列表",
      method: "GET",
      path: "/listForModified"
    },
    {
      name: "auditModify",
      desc: "审核资料修改",
      method: "POST",
      path: "/auditModify"
    },
    {
      name: "listForWaitCer",
      desc: "获取待发证列表",
      method: "GET",
      path: "/listForWaitCer"
    },
    {
      name: "delete",
      desc: "删除",
      method: "GET",
      path: "/remove"
    },
    {
      name: "audit",
      desc: "审批",
      method: "POST",
      path: "/audit"
    },
    {
      name: "history",
      desc: "历史申报",
      method: "GET",
      path: "/history"
    },
    {
      name: "wait-cer",
      desc: "设置待发证",
      method: "POST",
      path: "/auditForWaitCer"
    },
    {
      name: "auditForExit",
      desc: "退出确认",
      method: "POST",
      path: "/auditForExit"
    },
    {
      name: "declare-update",
      desc: "更新申报信息",
      method: "POST",
      path: "/update"
    },
    {
      name: "can-cer",
      desc: "设置为发证",
      method: "POST",
      path: "/auditForCer"
    },
    //导出所有接口
    {
      name: "exportAll",
      desc: "导出全部",
      method: "POST",
      path: "/exportAll"
    },
    {
      name: "exportSubmitted",
      desc: "导出待初审",
      method: "POST",
      path: "/exportSubmitted"
    },
    {
      name: "exportAudited",
      desc: "导出已立项",
      method: "POST",
      path: "/exportAudited"
    },
    {
      name: "exportCheck",
      desc: "导出待验收",
      method: "POST",
      path: "/exportCheck"
    },
    {
      name: "exportApproved",
      desc: "导出已审定",
      method: "POST",
      path: "/exportApproved"
    },
    {
      name: "exportWaitCer",
      desc: "导出证书管理下申报",
      method: "POST",
      path: "/exportWaitCer"
    },
    {
      name: "exportFormDataSummary",
      desc: "导出资料已上传下申报",
      method: "POST",
      path: "/exportFormDataSummary"
    },
    {
      name: "exportReject",
      desc: "导出-驳回/已退出",
      method: "POST",
      path: "/exportReject"
    },
    //统计数据
    {
      name: "dictYear",
      desc: "申报年份数据字典",
      method: "GET",
      path: "/dict/year"
    },
    {
      name: "dictBatch",
      desc: "申报批次数据字典",
      method: "GET",
      path: "/dict/batch"
    },
    {
      name: "countCurrentList",
      desc: "申报中数据统计表",
      method: "POST",
      path: "/count/current"
    },
    {
      name: "countHistoryYearList",
      desc: "历史申报年度统计表",
      method: "POST",
      path: "/count/history/year"
    },
    {
      name: "countHistoryBatchList",
      desc: "历史申报年度统计表",
      method: "POST",
      path: "/count/history/batch"
    },
    {
      name: "currentExport",
      desc: "申报中数据统计表-导出",
      method: "POST",
      path: "/count/currentExport"
    },
    {
      name: "yearExport",
      desc: "历史申报年度统计表-导出",
      method: "POST",
      path: "/count/history/yearExport"
    },
    {
      name: "batchExport",
      desc: "历史申报批次统计表-导出",
      method: "POST",
      path: "/count/history/batchExport"
    },
    {
      name: "batchAuditForWaitCer",
      desc: "批量待发证（v1.3-第二批次）",
      method: "POST",
      path: "/batchAuditForWaitCer"
    }
  ]
};



// WEBPACK FOOTER //
// ./src/api/psm/sp/admin.js